import React, { FC, useState } from 'react'

import { Icon, Modal, StandardButton, Txt } from 'src/components/atoms'

import { useCommonContentAsset, useGetCommonContentPages, useToast } from 'src/hooks'
import { CommonContentAssetEntity } from 'src/types'

type Props = {
  asset: CommonContentAssetEntity
  isOpen: boolean
  onClose: () => void
}

export const CommonContentAssetDeleteModal: FC<Props> = ({ asset, isOpen, onClose }) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const { deleteCommonContentAsset } = useCommonContentAsset()
  const { refetch } = useGetCommonContentPages()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()

  const handleOnDelete = async () => {
    setIsDeleting(true)

    try {
      await deleteCommonContentAsset({ commonContentPageId: asset.pageId, assetId: asset.id })
      displayStandardTextToast('削除しました')
      refetch()
      onClose()
    } catch {
      displayErrorTextToast('削除に失敗しました')
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-flex tw-items-center">
            <Icon size="--r1" path="trash/soft/line" className="tw-accent-standardText-secondary" />
            <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
              ファイルを削除
            </Txt>
          </div>
        </div>
      }
    >
      <div className="tw-w-[39.14rem] tw-p-s2">
        <div>
          <Txt tag="span" className="tw-text-standardText-secondary">
            名称：
          </Txt>
          <Txt tag="span" className="tw-break-all">
            {asset.name && asset.name !== '' ? asset.name : '-'}
          </Txt>
        </div>

        <div className="tw-centering tw-mt-s3">
          <StandardButton
            buttonType="secondary"
            text="キャンセル"
            prependIconPath="close/soft/line"
            size="l"
            onClick={onClose}
          />
          <StandardButton
            buttonType="danger"
            text="削除"
            prependIconPath="trash/soft/line"
            isLoading={isDeleting}
            size="l"
            onClick={handleOnDelete}
            className="tw-ml-s2"
          />
        </div>
      </div>
    </Modal>
  )
}
